var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('img',{attrs:{"src":_vm.flag,"height":"16"}}),(!_vm.hideText)?_c('span',[_vm._v(" "+_vm._s(_vm._f("translate")(_vm.text))+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }